module.exports = __webpack_public_path__ + "8e4472a1954a1a51dd1e4f5b8e1ab2e4.pdf";